import { render } from "./userstabset.vue?vue&type=template&id=b451bd8a"
import script from "./userstabset.vue?vue&type=script&lang=js"
export * from "./userstabset.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__